package com.solevo.dist.network.firebase.api.quotes.models

import com.solevo.dist.application.models.Quote
import com.solevo.dist.application.models.QuoteLine
import com.solevo.dist.application.models.QuoteStatus
import com.solevo.dist.network.implementation.firebase.utils.time.toKotlinInstant
import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
data class FirebaseQuote(
    val quoteId: String = "",
    val totalAmount: Double? = null,
    val status: QuoteStatus = QuoteStatus.Awaiting,
    val createdAt: Timestamp = Timestamp.now(),
    val quoteLines: List<QuoteLine>? = null,
    val unread: Boolean = false,
    val legalEntityId: String = "",
    val customerId: String = "",
    val createdBy: String? = null,
    val acceptedBy: String? = null,
    val pickupDateFrom: Timestamp? = Timestamp.now(),
    val pickupDateTo: Timestamp? = Timestamp.now(),
    val quoteExpirationDate: Timestamp? = Timestamp.now(),
    val pickupToday: Boolean = true,
    val orderReference: String? = "",
    val subTotal: Double = 0.0,
    val tax: Double = 0.0,
    var appQuote: Boolean? = null,
    var errorCode: String? = null,
    var errorText: String? = null,
    var updatedBy: String? = null
)

fun FirebaseQuote.toQuote(): Quote {
    return Quote(
        quoteId = quoteId,
        totalAmount = totalAmount,
        status = status,
        createdAt = createdAt.toKotlinInstant(),
        quoteLines = quoteLines,
        unread = unread,
        legalEntityId = legalEntityId,
        customerId = customerId,
        createdBy = createdBy,
        acceptedBy = acceptedBy,
        pickupDateFrom = pickupDateFrom?.toKotlinInstant(),
        pickupDateTo = pickupDateTo?.toKotlinInstant(),
        quoteExpirationDate = quoteExpirationDate?.toKotlinInstant(),
        pickupToday = pickupToday,
        orderReference = orderReference,
        subTotal = subTotal,
        tax = tax,
        appQuote = appQuote,
        errorCode = errorCode,
        errorText = errorText,
        updatedBy = updatedBy
    )
}


